<template>
  <aside class="ca-sidebar">
    <div class="ca-sidebar__title">个人中心</div>
    <ul class="ca-sidebar__list">
      <li
        v-for="m in menus"
        :key="m.key"
        class="ca-sidebar__item"
        :class="{ 'is-active': activeKey === m.key }"
        @click="go(m)"
      >
        {{ m.label }}
      </li>
    </ul>
  </aside>
</template>

<script>
/**
 * 左侧导航的单一事实源：菜单项、跳转目标、选中态判定都在本组件，
 * 页面组件禁止自行判定选中态。
 *
 * ✅ R8 已确认（2026-09-20）：菜单固定 2 项「我的订单」「联系我们」（顺序即渲染顺序）。
 * ⚠️ 原型 `CA续签.png` / `联系我们.png` 的左栏是 3 项（多一个「在线续签」），落地按 2 项；
 *   续签页仅由订单卡「信息认证」进入，无菜单入口（R12），不要照原型补回。
 *
 * routeName 对应 `src/router/index.js` 中 CA 路由的 `name`；
 * 跳转时用 `{ name }`，避免手拼 path。
 */
const MENUS = [
  { key: 'orders', label: '我的订单', routeName: 'ca-orders' },
  { key: 'contact', label: '联系我们', routeName: 'ca-contact' },
]

export default {
  name: 'CaSidebar',
  data() {
    return {
      menus: MENUS,
    }
  },
  computed: {
    // 选中项判定（R9）：除「联系我们」页外，其余页面（订单详情 / 编辑 / 续签 / 支付订单等
    // 从订单跳转的二级页）一律高亮「我的订单」；组件内不做任何其他 path 判断
    activeKey() {
      return /\/contact(\/|$)/.test(this.$route.path || '') ? 'contact' : 'orders'
    },
  },
  methods: {
    go(menu) {
      if (this.$route.name !== menu.routeName) {
        this.$router.push({ name: menu.routeName })
      }
    },
  },
}
</script>
